<script setup lang="ts">
import EventAutocomplete from '@/components/Filters/EventAutocomplete.vue'
import type { EventCheckpointType } from '@/types/filters/EventCheckpointType'
import type { EventQueryFilters } from '@/types/filters/EventFilters'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import type { EventModel } from '@/types/models/EventModel'
import CheckpointAutocomplete from './CheckpointAutocomplete.vue'

type Props = EventCheckpointType & {
    keepEventInStorage?: boolean
    hideEventSelector?: boolean
    filterAllEvents?: boolean
    filters?: EventQueryFilters
    useQueryResponse?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: EventCheckpointType): void
    (e: 'selectEvent', value?: EventModel): void
    (e: 'associates', value?: AssociatedDeviceModel[]): void
    (e: 'selectCheckpoint', value?: CheckpointModel): void
}
const emit = defineEmits<Emits>()

const handleSelectCheckpoint = (value: CheckpointModel | undefined) => {
    emit('selectCheckpoint', value)
    emit('associates', value?.associates)
}
</script>

<template>
    <EventAutocomplete
        v-if="!hideEventSelector"
        :event="event"
        :keepEventInStorage="keepEventInStorage"
        :filterAllEvents="filterAllEvents"
        :filters="filters"
        @change="$emit('selectEvent', $event)"
        class="w-full" />
    <CheckpointAutocomplete
        :disabled="!event?.id"
        :event="event"
        :checkpoint="checkpoint"
        :filters="filters"
        :useQueryResponse="useQueryResponse"
        @change="handleSelectCheckpoint($event)"
        class="w-full" />
</template>
